export default __webpack_public_path__ + "static/media/rambouillet16.822e8688.jpg";